import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SideMenu from "./components/SideMenu";
import Departamentos from "./Departamentos";
import Bancos from "./Bancos";
import Funcoes from "./Funcoes";
import Categorias from "./Categorias";
import TiposDocumento from "./TiposDocumento";
import Rateios from "./Rateios";
import LocaisCobranca from "./LocaisCobranca";
import ScreenBanner from "../../../../components/ScreenBanner";
import Dashboard from "./Dashboard";
import ConfiguracoesBancarias from "./ConfiguracoesBancarias";
import { ConfirmProvider } from "material-ui-confirm";
import OperadorasCartao from "./OperadorasCartao";
import CCOConfiguracoes from "./CCOConfiguracoes";
import Situacoes from "./Situacoes";
import PermissionGuard from "../../../../components/PermissionGuard";
import TEFConfiguracoes from "./TEF";

export default function ConfiguracoesFinanceiro() {

    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [configSelecionada, setConfigSelecionada] = useState<TConfigSelect>(params.get('menu') as TConfigSelect || "Dashboard")

    //Funções Manipuladoras
    const handleSelectItemConfig = useCallback((config: TConfigSelect) => {
        setConfigSelecionada(config)
        navigate(`/financeiro/configuracoes?menu=${config}`);
    }, [navigate])
    //

    //Valores importantes
    const renderContent = useMemo(() => {
        if (configSelecionada === "Dashboard") {
            return <Dashboard />
        }
        if (configSelecionada === "Departamentos") {
            return <Departamentos />
        }
        if (configSelecionada === "Bancos") {
            return <Bancos />
        }
        if (configSelecionada === "Funções") {
            return <Funcoes />
        }
        if (configSelecionada === "Situações") {
            return <Situacoes />
        }
        if (configSelecionada === "Categorias") {
            return <Categorias />
        }
        if (configSelecionada === "Tipos de documento") {
            return <TiposDocumento />
        }
        if (configSelecionada === "Rateios") {
            return <Rateios />
        }
        if (configSelecionada === "Locais de cobrança") {
            return <LocaisCobranca />
        }
        if (configSelecionada === "Configurações bancárias") {
            return <ConfiguracoesBancarias />
        }
        if (configSelecionada === "Configuração TEF") {
            return <TEFConfiguracoes />
        }
        if (configSelecionada === "Operadoras de cartão") {
            return <OperadorasCartao />
        }
        if (configSelecionada === "Conta consumo") {
            return <CCOConfiguracoes />
        }
    }, [configSelecionada])
    //

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setConfigSelecionada(params.get('menu') as TConfigSelect || "Dashboard");
    }, [location.search]);

    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.configuracoes">
                <Container sx={{ my: 4 }}>
                    <Typography textAlign="center" variant="h5">Configurações financeiras</Typography>
                    <Grid container spacing={2} mt={1}>
                        <Grid size={{xs: 12, md: 4}}>
                            <Box component={Paper} p={2}>
                                <SideMenu
                                    select={configSelecionada}
                                    handleSelect={(item) => handleSelectItemConfig(item)}
                                />
                            </Box>
                        </Grid>

                        <Grid size={{xs: 12, md: 8}}>
                            <Box component={Paper} p={2}>
                                <ConfirmProvider defaultOptions={{
                                    title: 'Excluir item',
                                    cancellationText: "Cancelar",
                                    confirmationText: "Excluir",
                                    confirmationButtonProps: { variant: 'contained', color: 'error' }
                                }}>
                                    {renderContent}
                                </ConfirmProvider>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </PermissionGuard>
        </>
    )
}

export type TConfigSelect = "Dashboard" | "Departamentos" | "Bancos" | "Funções" | "Categorias" | "Tipos de documento" | "Rateios" | "Locais de cobrança" | "Configurações bancárias" | "Operadoras de cartão" | "Conta consumo" | "Situações" | "Configuração TEF"

export type TConfigModalState = {
    [key in TConfigSelect]?: boolean;
};